import React from "react";
import "./Tooltip.scss";

const Tooltip = ({ text, position = "top", showFlag = false, children, positionX, positionY, onClick}) => {
    const hasTooltip = !!text && showFlag;
    // Mapeo de coordenadas para las 9 posiciones
    const positions = {
        x: {
            left: { left: '0%', transformX: '-100%', marginX: '-10px' },
            center: { left: '50%', transformX: '-50%', marginX: '0' },
            right: { left: '100%', transformX: '0%', marginX: '10px' },
        },
        y: {
            top: { top: '0%', transformY: '-100%', marginY: '-10px' },
            center: { top: '50%', transformY: '-50%', marginY: '0' },
            bottom: { top: '100%', transformY: '0%', marginY: '10px' },
        }
    };

    const useNewSystem = positionX !== undefined && positionY !== undefined;

    const dynamicStyle = useNewSystem ? {
        left: positions.x[positionX]?.left || '50%',
        top: positions.y[positionY]?.top || '0%',
        transform: `translate(${positions.x[positionX]?.transformX || '-50%'}, ${positions.y[positionY]?.transformY || '-100%'})`,
        marginLeft: positions.x[positionX]?.marginX || '0',
        marginTop: positions.y[positionY]?.marginY || '0',
    } : {}; // Si no se usan, el objeto va vacío para no sobreescribir el CSS
    return (
        <div className={`tooltip-container ${hasTooltip ? "has-tooltip" : ""}`} onClick={onClick}>
            {children}

            {text && (positionX && positionY ?
                <div className={`tooltip-text-container`} style={dynamicStyle}>
                    <span className='tooltip-text'>{text}</span>
                </div>
                :
                <div className={`tooltip-text-container tooltip-${position}`}>
                    <span className='tooltip-text'>{text}</span>
                </div>
            )}
        </div>
    );
};

export default Tooltip;

